<template>
  <div>
    <main class="main-content">
      <div class="page-content">
        <div class="container">
          <div class="page-links">
            <router-link to='/settings/territory' class="page-links__item">Territory</router-link>
            <router-link to='/settings/location' class="page-links__item">Location</router-link>
            <router-link to='/settings/area' class="page-links__item">Area</router-link>
            <router-link to='/settings/airstrip' class="page-links__item is-active">Airstrip</router-link>
          </div>
          <div class="lds-ring" v-if="!isLoad">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <section class="geo-section geo-section--airstrip" v-if="isLoad">
            <div class="page-title">
              <h2>Setting & Data | Geo | Airstrip</h2>
            </div>
            <div class="geo-section__add">
              <div class="section-title">
                <h3>Add airstrip</h3>
              </div>
              <form action="javascript:void(0)" class="geo-section__airstrip-form">
                <div class="add-block__container">
                  <div class="form-control-group"><span class="form-control-label">Title</span>
                    <div :class="['form-control-wrap', { 'is-error' : errors.title}]">
                      <input type="text" Placeholder="Title" v-model="add.title" @focus="errors.title = false"
                             class="form-control"/>
                    </div>
                  </div>
                  <div :class="['form-control-group', { 'is-error' : errors.territory}]"><span class="form-control-label">Territory</span>
                    <div :class="['select-wrapper', { 'is-active' : selects.territory }]"
                         @click="changeSelects('territory');errors.territory = false">
                      <div class="select-trigger"><span
                          class="select-trigger__name">{{
                          territories.find(item => item.active) && territories.find(item => item.active).names.EN || 'Choose'
                        }}</span><span
                          class="select-trigger__icon">
                                <svg width="1em" height="1em" class="icon icon-chevron ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                </svg></span></div>
                      <div class="select-body">
                        <div class="select-inner">
                          <div
                              v-for="item in territories"
                              :key="item.id"
                              :class="['select-option', {'is-selected' : item.active}]"
                              @click="territories = territories.map(territory => territory.id === item.id ? {...territory, active: true} : {...territory, active: false})">
                            <span class="select-option__name">{{ item.names.EN }}</span></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div :class="['form-control-group', { 'is-error' : errors.location}]"
                       :style="{opacity: locations.length ? 1 : .6, cursor: locations.length ? 'pointer' : 'default', pointerEvents: locations.length ? 'auto' : 'none'}">
                    <span class="form-control-label">Location</span>
                    <div :class="['select-wrapper', { 'is-active' : selects.location && locations.length }]"
                         @click="territories.find(item => item.active) && locations.length ? changeSelects('location') : false;errors.location = false">
                      <div class="select-trigger"><span
                          class="select-trigger__name">{{
                          locations.find(item => item.active) && locations.find(item => item.active).names.EN || 'Choose'
                        }}</span><span
                          class="select-trigger__icon">
                                <svg width="1em" height="1em" class="icon icon-chevron ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                </svg></span></div>
                      <div class="select-body">
                        <div class="select-inner">
                          <div
                              v-for="item in locations"
                              :key="item.id"
                              :class="['select-option', {'is-selected' : item.active}]"
                              @click="locations = locations.map(location => location.id === item.id ? {...location, active: true} : {...location, active: false})">
                            <span class="select-option__name">{{ item.names.EN }}</span></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div :class="['form-control-group', { 'is-error' : errors.area}]"
                       :style="{opacity: areas.length ? 1 : .6, cursor: areas.length ? 'pointer' : 'default', pointerEvents: areas.length ? 'auto' : 'none'}">
                    <span class="form-control-label">Area</span>
                    <div :class="['select-wrapper', { 'is-active' : selects.areas }]"
                         @click="territories.find(item => item.active) && locations.find(item => item.active) && areas.length ? changeSelects('areas') : false;errors.area = false">
                      <div class="select-trigger"><span
                          class="select-trigger__name">{{
                          areas.length === 0 ? 'Choose' : areas.filter(item => item.active).map(item => item.names.EN).join(', ')
                        }}</span><span
                          class="select-trigger__icon">
                                <svg width="1em" height="1em" class="icon icon-chevron ">
                                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                </svg></span></div>
                      <div class="select-body">
                        <div class="select-inner">
                          <div
                              v-for="item in areas"
                              :key="item.id"
                              :class="['select-option', { 'is-selected' : item.active }]">
                            <label class="form-control-checkbox" @click.stop="item.active = !item.active">
                              <input type="checkbox" :checked="item.active" @click.prevent.stop/><span
                                class="form-control-checkbox__box">
                                      <svg width="1em" height="1em" class="icon icon-check ">
                                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
                                      </svg></span><span class="select-option__name">{{ item.names.EN }}</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-control-group"><span class="form-control-label">Place ID</span>
                  <div :class="['form-control-wrap', { 'is-error' : errors.googlePlaceId}]">
                    <input type="text" Placeholder="Place ID" v-model="add.googlePlaceId" @focus="errors.googlePlaceId = false"
                           class="form-control"/>
                  </div>
                </div>
                </div>
                <button type="submit" class="btn btn--green geo-section__airstrip-form__submit"
                        @click="addAirstripHandler"><span>Add</span></button>
              </form>
            </div>
            <div class="geo-section__airstrip">
              <div class="section-title">
                <h3>Airstrips</h3>
                <div class="form-control-wrap">
                  <input type="text" placeholder="Search" v-model="search" class="form-control-search"/>
                  <div class="form-control-icon">
                    <svg width="1em" height="1em" class="icon icon-search ">
                      <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-search"></use>
                    </svg>
                  </div>
                </div>
              </div>
              <div data-simplebar="data-simplebar" class="section-table-wrap">
                <div class="section-table section-table--geo">
                  <div class="section-table__head">
                    <div class="col col-airstrip"><span>Airstrip</span></div>
                    <div class="col col-territory"><span>Territory</span></div>
                    <div class="col col-location"><span>Location</span></div>
                    <div class="col col-airstrip-area"><span>Area</span></div>
                    <div class="col col-added"><span>Added</span></div>
                    <div class="col col-edited"><span>Edited</span></div>
                  </div>
                  <div class="section-table__body">
                    <div class="section-table__row"
                         v-for="(item, index) in airstrips.slice((page - 1) * 15, ((page - 1) * 15) + 15)"
                         :key="item.airstrip.id">
                      <div class="col col-airstrip">
                        <div class="section-table__row__number">{{ index + 1 }}</div>
                        <div class="section-table__row__name">{{ item.airstrip.names.EN }}</div>
                      </div>
                      <div class="col col-territory"><span>{{ item.territory.names.EN }}</span></div>
                      <div class="col col-location"><span>{{ item.location.names.EN }}</span></div>
                      <div class="col col-airstrip-area">
                        <span>{{
                            item.areas.map(item => item.names.EN).slice(0, 2).join(', ')
                          }} {{ item.areas.length > 2 ? `and ${item.areas.length - 2} others` : '' }}</span>
                      </div>
                      <div class="col col-added"><span>{{ item.airstrip.createdAt }}</span></div>
                      <div class="col col-edited"><span>{{ item.airstrip.updatedAt }}</span></div>
                      <div class="col col-actions">
                        <button type="button" class="btn btn--edit" @click="editAirstrip(item.airstrip.id)">
                          <svg width="1em" height="1em" class="icon icon-edit ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use>
                          </svg>
                        </button>
                        <button type="button" class="btn btn--remove" @click="$emit('deleteModalHandler', {
                                            entity: 'Airstrip',
                                            name: item.airstrip.title,
                                            handler: deleteAirstrioHandler,
                                            id: item.airstrip.id
                                        })">
                          <svg width="1em" height="1em" class="icon icon-close ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Pagination
                  :page="page"
                  :pageCount="pageCount"
                  @pageController="pageController"
              />
            </div>
          </section>
        </div>
      </div>
    </main>
    <div class="modal-wrapper" v-if="edit">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup edit-popup--airstrip">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <div class="edit-popup__title__icon" :style="{minWidth: '21px'}">
                <svg width="1em" height="1em" class="icon icon-edit ">
                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use>
                </svg>
              </div>
              <span :style="{whiteSpace: 'nowrap'}">Edit Airstrip</span>
            </div>
            <div class="form-control-group form-control-group-lang-horiz"
                 :style="{justifyContent: 'flex-end', marginRight: '2rem'}"><span
                class="form-control-label">Language:</span>
              <div :class="['select-wrapper select-wrapper__lang', { 'is-active' : selects.langEdit } ]"
                   @click="changeSelects('langEdit')" :style="{width: '16rem'}">
                <div class="select-trigger">
                  <div class="select-trigger__flag__icon">
                    <svg width="1em" height="1em" class="icon icon-rus"
                         :style="langEdit === 'DE' || langEdit === 'ES' ? {width: '18px', height: '18px', marginBottom: '1px'} : {}">
                      <use :xlink:href="getLanguageIcon(langEdit)"></use>
                    </svg>
                  </div>
                  <span
                      class="select-trigger__name">{{getLanguageTitle(langEdit) }}</span><span
                    class="select-trigger__icon">
                            <svg width="1em" height="1em" class="icon icon-chevron ">
                              <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                            </svg></span>
                </div>
                <div class="select-body">
                  <div class="select-inner js-scrollbar">
                    <div class="select-option" @click="langEdit = 'RU'"><span class="select-option__name">
                                <div class="select-trigger__flag__icon">
                                  <svg width="1em" height="1em" class="icon icon-ru">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-ru"></use>
                                  </svg>
                                </div>Russian
                              </span></div>
                    <div class="select-option" @click="langEdit = 'EN'"><span class="select-option__name">
                                <div class="select-trigger__flag__icon">
                                  <svg width="1em" height="1em" class="icon icon-usa">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-usa"></use>
                                  </svg>
                                </div>English
                              </span>
                    </div>
                    <div class="select-option" @click="langEdit = 'DE'"><span class="select-option__name">
                                <div class="select-trigger__flag__icon">
                                  <svg width="1em" height="1em" class="icon icon-rus"
                                       :style="{width: '18px', height: '18px', marginBottom: '1px'}">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-deu"></use>
                                  </svg>
                                </div>Deutch
                              </span></div>
                    <div class="select-option" @click="langEdit = 'ES'">
                      <span class="select-option__name">
                        <div class="select-trigger__flag__icon">
                          <svg width="1em" height="1em" class="icon icon-deu"
                               :style="{width: '18px', height: '18px', marginBottom: '1px'}">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-es"></use>
                          </svg>
                        </div>
                        Spanish
                      </span>
                    </div>
                    <div class="select-option" @click="langEdit = 'FR'">
                      <span class="select-option__name">
                        <div class="select-trigger__flag__icon">
                          <svg width="1em" height="1em" class="icon icon-deu"
                               :style="{width: '18px', height: '18px', marginBottom: '1px'}">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-fr"></use>
                          </svg>
                        </div>
                        French
                      </span>
                    </div>
                    <div class="select-option" @click="langEdit = 'PT'">
                      <span class="select-option__name">
                        <div class="select-trigger__flag__icon">
                          <svg width="1em" height="1em" class="icon icon-deu"
                               :style="{width: '18px', height: '18px', marginBottom: '1px'}">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-pt"></use>
                          </svg>
                        </div>
                        Portuguese
                      </span>
                    </div>
                    <div class="select-option" @click="langEdit = 'NL'">
                      <span class="select-option__name">
                        <div class="select-trigger__flag__icon">
                          <svg width="1em" height="1em" class="icon icon-deu"
                               :style="{width: '18px', height: '18px', marginBottom: '1px'}">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-nl"></use>
                          </svg>
                        </div>
                        Dutch
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="edit-popup__close" @click="isEdit ? $emit('notLeavePopupHandler', { handler: clearEdit }) : edit = null">
              <svg width="1em" height="1em" class="icon icon-close ">
                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <form action="javascript:void(0)" class="edit-popup__inner">
            <div class="edit-popup__side">
              <div class="form-control-group"><span class="form-control-label">Title</span>
                <div :class="['form-control-wrap', { 'is-error' : errorsEdit.title}]">
                  <input type="text" Placeholder="Title" @change="isEdit = true" @focus="errorsEdit.title = false"
                         v-model="edit.names[langEdit]" class="form-control">
                </div>
              </div>
            </div>
            <div class="edit-popup__side">
              <div :class="['form-control-group', { 'is-error' : errorsEdit.territory}]"><span
                  class="form-control-label">Territory</span>
                <div :class="['select-wrapper', { 'is-active' : selects.territoryEdit }]"
                     :style="{opacity: territoriesEdit.length ? 1 : .6, cursor: territoriesEdit.length ? 'pointer' : 'default', pointerEvents: territoriesEdit.length ? 'auto' : 'none'}"
                     @click="changeSelects('territoryEdit');errorsEdit.territory = false">
                  <div class="select-trigger"><span
                      class="select-trigger__name">{{
                      territoriesEdit.find(item => item.active) && (territoriesEdit.find(item => item.active).names[langEdit] || territoriesEdit.find(item => item.active).names['EN']) || 'Choose'
                    }}</span><span
                      class="select-trigger__icon">
                                <svg width="1em" height="1em" class="icon icon-chevron ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                </svg></span></div>
                  <div class="select-body">
                    <div class="select-inner">
                      <div
                          v-for="item in territoriesEdit"
                          :key="item.id"
                          :class="['select-option', {'is-selected' : item.active}]"
                          @click="territoriesEdit = territoriesEdit.map(territory => territory.id === item.id ? {...territory, active: true} : {...territory, active: false});isEdit = true">
                        <span class="select-option__name">{{ item.names[langEdit] || item.names['EN'] }}</span></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="edit-popup__side">
              <div :class="['form-control-group', { 'is-error' : errorsEdit.location}]"><span
                  class="form-control-label">Location</span>
                <div :class="['select-wrapper', { 'is-active' : selects.locationEdit }]"
                     :style="{opacity: locationsEdit.length ? 1 : .6, cursor: locationsEdit.length ? 'pointer' : 'default', pointerEvents: locationsEdit.length ? 'auto' : 'none'}"
                     @click="territoriesEdit.find(item => item.active) && locationsEdit.length ? changeSelects('locationEdit') : false;errorsEdit.location = false">
                  <div class="select-trigger"><span
                      class="select-trigger__name">{{
                      locationsEdit.find(item => item.active) && (locationsEdit.find(item => item.active).names[langEdit] || locationsEdit.find(item => item.active).names['EN']) || 'Choose'
                    }}</span><span
                      class="select-trigger__icon">
                                <svg width="1em" height="1em" class="icon icon-chevron ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                </svg></span></div>
                  <div class="select-body">
                    <div class="select-inner">
                      <div
                          v-for="item in locationsEdit"
                          :key="item.id"
                          :class="['select-option', {'is-selected' : item.active}]"
                          @click="locationsEdit = locationsEdit.map(location => location.id === item.id ? {...location, active: true} : {...location, active: false});isEdit = true">
                        <span class="select-option__name">{{ item.names[langEdit] || item.names['EN'] }}</span></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="edit-popup__side">
              <div :class="['form-control-group', { 'is-error' : errorsEdit.area}]"><span class="form-control-label">Area</span>
                <div :class="['select-wrapper', { 'is-active' : selects.areasEdit }]"
                     :style="{opacity: areasEdit.length ? 1 : .6, cursor: areasEdit.length ? 'pointer' : 'default', pointerEvents: areasEdit.length ? 'auto' : 'none'}"
                     @click="territoriesEdit.find(item => item.active) && locationsEdit.find(item => item.active) && areasEdit.length ? changeSelects('areasEdit') : false;errorsEdit.area = false">
                  <div class="select-trigger"><span
                      class="select-trigger__name">{{
                      areasEdit.length === 0 ? 'Choose' : (areasEdit.filter(item => item.active).map(item => item.names[langEdit] || item.names['EN']).join(', '))
                    }}</span><span
                      class="select-trigger__icon">
                              <svg width="1em" height="1em" class="icon icon-chevron ">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                              </svg></span></div>
                  <div class="select-body">
                    <div class="select-inner">
                      <div
                          v-for="item in areasEdit"
                          :key="item.id"
                          :class="['select-option', { 'is-selected' : item.active }]">
                        <label class="form-control-checkbox" @click.stop="item.active = !item.active;isEdit = true">
                          <input type="checkbox" :checked="item.active" @click.prevent.stop/><span
                            class="form-control-checkbox__box">
                                    <svg width="1em" height="1em" class="icon icon-check ">
                                      <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
                                    </svg></span><span class="select-option__name">{{ item.names[langEdit] || item.names['EN'] }}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="edit-popup__side">
              <div class="form-control-group">
                <label class="form-control-checkbox"
                       @click.prevent="edit.transferTerritorial = !edit.transferTerritorial;isEdit = true">
                  <input type="checkbox" :checked="edit.transferTerritorial"><span class="form-control-checkbox__box">
                            <svg width="1em" height="1em" class="icon icon-check ">
                                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
                            </svg></span><span class="form-control-checkbox__name">Transfer territorial</span>
                </label>
              </div>
            </div>
            <div class="edit-popup__side">
              <div class="form-control-group"><span class="form-control-label">Place ID</span>
                <div :class="['form-control-wrap', { 'is-error' : errorsEdit.googlePlaceId}]">
                  <input type="text" Placeholder="Place ID" @change="isEdit = true" @focus="errorsEdit.googlePlaceId = false"
                         v-model="edit.googlePlaceId" class="form-control">
                </div>
              </div>
            </div>
            <div class="edit-popup__side">
              <button type="submit" class="btn btn--green edit-popup__submit" @click="updateAirstripHandler">
                <span>Save</span></button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {
  getAirstripsAll,
  getTerritoriesAll,
  createAirstrip,
  deleteAirstrip,
  getLocationsTerritoriesAll,
  getAreasLocaitonAll,
  getAirstrip,
  updateAirstrip
} from '@/utilites/api'

import Pagination from '@/components/Pagination'
import { getLanguageIcon, getLanguageTitle } from '../../common/helpers/language'

export default {
  props: ['user'],
  components: {Pagination},
  data() {
    return {
      airstrips: [],
      airstripsData: [],
      locations: [],
      territories: [],
      areas: [],
      locationsEdit: [],
      territoriesEdit: [],
      areasEdit: [],
      langEdit: 'EN',
      add: {
        title: '',
        territory: '',
        location: '',
        areas: [],
        googlePlaceId: null,
      },
      selects: {
        territory: false,
        location: false,
        areas: false,
        territoryEdit: false,
        locationEdit: false,
        areasEdit: false,
        langEdit: false
      },
      page: 1,
      pageCount: 0,
      search: '',
      edit: null,
      isLoad: false,
      isEdit: false,
      errors: {
        title: false,
        territory: false,
        location: false,
        area: false
      },
      errorsEdit: {
        title: false,
        territory: false,
        location: false,
        area: false
      }
    }
  },
  beforeCreate() {
    document.title = 'Setting & Data / Geo / Airstrip'
  },
  mounted() {
    document.title = 'Setting & Data / Geo / Airstrip'
    getTerritoriesAll(this.user.access_token)
        .then(res => {
          this.territories = res.map(item => ({...item, active: false}))
          this.territoriesEdit = res.map(item => ({...item, active: false}))
        })
    this.updateData()
    window.addEventListener('click', event => {
      if (!event.target.closest('.select-wrapper')) {
        this.selects = {
          territory: false,
          location: false,
          areas: false,
          territoryEdit: false,
          locationEdit: false,
          areasEdit: false,
          langEdit: false
        }
      }
      if (!event.target.closest('.edit-popup') && !event.target.closest('.btn')) {
        if (this.isEdit) {
          this.$emit('notLeavePopupHandler', {
            handler: this.clearEdit
          })
        } else {
          this.edit = false
        }
      }
    })
  },
  methods: {
    getLanguageIcon,
    getLanguageTitle,
    changeSelects(target) {
      this.selects = {
        territory: false,
        location: false,
        areas: false,
        territoryEdit: false,
        locationEdit: false,
        areasEdit: false,
        langEdit: false,
        [target]: !this.selects[target]
      }
    },
    checkErrors() {
      this.errors = {
        title: this.add.title.trim().length === 0,
        territory: !this.territories.find(item => item.active),
        location: !this.locations.find(item => item.active),
        area: this.areas.filter(item => item.active).length === 0
      }
      let error = false
      for (const key in this.errors) {
        if (this.errors[key]) {
          error = true
        }
      }
      return error
    },
    checkErrorsEdit() {
      this.errorsEdit = {
        title: this.edit.names.EN.trim().length === 0,
        territory: !this.territoriesEdit.find(item => item.active),
        location: !this.locationsEdit.find(item => item.active),
        area: this.areasEdit.filter(item => item.active).length === 0
      }
      let error = false
      for (const key in this.errorsEdit) {
        if (this.errorsEdit[key]) {
          error = true
        }
      }
      return error
    },
    pageController(page) {
      this.page = page
    },
    pageCountHandler() {
      this.pageCount = Math.ceil(this.airstrips.length / 15)
    },
    addAirstripHandler() {
      if (!this.checkErrors()) {
        createAirstrip(this.user.access_token, {
          names: {
            EN: this.add.title,
            RU: this.add.title,
            DE: this.add.title,
            ES: this.add.title,
            FR: this.add.title,
            PT: this.add.title,
            NL: this.add.title,
          },
          areas: this.areas.filter(item => item.active).map(item => item.id),
          googlePlaceId: this.add.googlePlaceId,
        })
            .then(res => {
              this.updateData()
              this.add.title = ''
              this.add.googlePlaceId = null
              this.territories = this.territories.map(item => ({...item, active: false}))
              this.locations = this.locations.map(item => ({...item, active: false}))
              this.areas = this.areas.map(item => ({...item, active: false}))
              this.$emit('confirmed')
            })
            .catch(() => {
              this.$emit('errored')
              this.errors.title = true
            })
      }
    },
    editAirstrip(id) {
      getAirstrip(this.user.access_token, id)
          .then(res => {
            this.edit = res
            this.territoriesEdit = this.territoriesEdit.map(item => ({
              ...item,
              active: item.id === this.airstrips.find(item => item.airstrip.id === id).territory.id
            }))
          })
    },
    updateAirstripHandler() {
      if (!this.checkErrorsEdit()) {
        updateAirstrip(this.user.access_token, {
          names: this.edit.names,
          areas: this.areasEdit.filter(item => item.active).map(item => item.id),
          transferTerritorial: this.edit.transferTerritorial,
          id: this.edit.id,
          googlePlaceId: this.edit.googlePlaceId,
        })
            .then(res => {
              this.updateData()
              this.edit = null
              this.$emit('confirmed')
              this.isEdit = false
            })
            .catch(() => this.$emit('errored'))
      }
    },
    deleteAirstrioHandler(id) {
      deleteAirstrip(this.user.access_token, id)
          .then(() => {
            this.updateData()
            this.$emit('confirmed')
          })
    },
    updateData() {
      this.isLoad = false
      getAirstripsAll(this.user.access_token)
          .then(res => {
            this.isLoad = true
            this.airstrips = res
            this.airstripsData = res
          })
    },
    clearEdit() {
      this.edit = null
      this.isEdit = false
    },
  },
  watch: {
    airstrips() {
      this.pageCountHandler()
    },
    territories() {
      let territory = this.territories.find(item => item.active)
      if (territory && territory.id) {
        getLocationsTerritoriesAll(this.user.access_token, territory.id)
            .then(res => {
              this.locations = res.map(item => ({...item, active: false}))
            })
      } else {
        this.locations = []
      }
    },
    territoriesEdit() {
      let territory = this.territoriesEdit.find(item => item.active)
      if (territory && territory.id) {
        getLocationsTerritoriesAll(this.user.access_token, territory.id)
            .then(res => {
              this.locationsEdit = res.map(item => {
                return ({
                  ...item,
                  active: item.id === this.airstrips.find(item => item.airstrip.id === this.edit.id).location.id
                })
              })
            })
      } else {
        this.locationsEdit = []
      }
    },
    locations() {
      let location = this.locations.find(item => item.active)
      if (location && location.id) {
        getAreasLocaitonAll(this.user.access_token, location.id)
            .then(res => {
              this.areas = res.map(item => ({...item, active: false}))
            })
      } else {
        this.areas = []
      }
    },
    locationsEdit() {
      let location = this.locationsEdit.find(item => item.active)
      if (location && location.id) {
        getAreasLocaitonAll(this.user.access_token, location.id)
            .then(res => {
              this.areasEdit = res.map(item => ({
                ...item,
                active: this.airstrips.find(item => item.airstrip.id === this.edit.id).areas.map(item => item.id).includes(item.id)
              }))
            })
      } else {
        this.areasEdit = []
      }
    },
    search() {
      if (this.search.length === 0) {
        this.airstrips = this.airstripsData
      }
      this.page = 1
      let filtered = this.airstripsData.filter(item => this.search.length ? (item.airstrip.names.EN && item.airstrip.names.EN.toLowerCase().includes(this.search.toLowerCase())) ? item : false : item)
      this.airstrips = filtered
      this.pageCount = Math.ceil(filtered.length / 15)
    },
    edit() {
      if (this.edit) {
        //     return ({...item, active: item.id === this.airstrips.find(item => item.airstrip.id === this.edit.id).location.id})
        // })
        this.areasEdit = this.areasEdit.map(item => ({...item, active: false}))
      }
    }
  }
}
</script>
<style scoped lang="scss">
.add-block__container {
  display: flex;
  margin: 10px 0;
  width: 100%;
}
</style>